module.exports = __webpack_public_path__ + "img/Number_Clue.1f4681cf.jpg";